module.exports = __webpack_public_path__ + "img/B - 02.e4a39c08.png";